<div class="reach-out">
    <div class="flex justify-between">
        <div class="flex items-center">
            <div>
                <div class="title-second-line md:text-56 sl:text-32">Connect to Ignite Our</div>
                 <div class="title-first-line md:text-56 sl:text-36">Cooperative Endeavor.</div>
                <button class="general-blue-button btn btn-primary contact-us-button" (click)="goContactUs()">Contact Us</button>
            </div>
        </div>
        <div class="reach-out-icon">
            <img src="/assets/images/reach-out.svg" />
        </div>
    </div>
</div>
